import { render, staticRenderFns } from "./chuangguan.vue?vue&type=template&id=c02619aa&scoped=true"
import script from "./chuangguan.vue?vue&type=script&lang=js"
export * from "./chuangguan.vue?vue&type=script&lang=js"
import style0 from "./chuangguan.vue?vue&type=style&index=0&id=c02619aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02619aa",
  null
  
)

export default component.exports